import AreaMapPopup from './AreaMapPopup';

export default AreaMapPopup;
